import Signup from '../components/SetupSignup.js';
export default {
  init() {
    Signup();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/signup.js